import { StateToken } from '@ngxs/store';
import { ApplyCvData } from '../../core/cv1g/lya-cv.types';

export interface SharedCvDataModel {
  cvData: ApplyCvData | null;
}
export const SHARED_CV_DATA_STATE_TOKEN = new StateToken<SharedCvDataModel>('sharedCvDataState');

export const INITIAL_SHARED_CV_DATA_STATE: SharedCvDataModel = {
  cvData: null,
};
